import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../../lib/api";

export const SOURCE_META = {
  sustek: { label: "SusTek Academy", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  linkedin_api: { label: "LinkedIn Learning", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  linkedin_link: { label: "LinkedIn Learning · link", cls: "bg-sky-50 text-sky-700 border-sky-200" },
};

export const LEVEL_CLS = {
  aware: "bg-slate-100 text-slate-600 border-slate-200",
  working: "bg-sky-50 text-sky-700 border-sky-200",
  proficient: "bg-violet-50 text-violet-700 border-violet-200",
  expert: "bg-amber-50 text-amber-700 border-amber-200",
};

export const fmtCpd = (v) => (Number.isInteger(Number(v)) ? String(v) : Number(v).toFixed(1));

export function useCourseActions() {
  const qc = useQueryClient();
  const invalidate = () => ["journey", "catalogue", "courses", "academy-summary", "control-tower"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
  const onError = (e) => toast.error(formatApiErrorDetail(e?.response?.data?.detail));
  const enroll = useMutation({ mutationFn: (id) => api.post(`/academy/courses/${id}/enroll`), onSuccess: () => { invalidate(); toast.success("Enrolled — course started"); }, onError });
  const complete = useMutation({ mutationFn: (id) => api.post(`/academy/courses/${id}/complete`), onSuccess: () => { invalidate(); toast.success("Course completed — CPD credits added!"); }, onError });
  const openLi = useMutation({ mutationFn: (id) => api.post(`/academy/linkedin/courses/${id}/open`), onSuccess: invalidate });
  const completeLi = useMutation({
    mutationFn: (id) => api.post(`/academy/linkedin/courses/${id}/complete`),
    onSuccess: (r) => { invalidate(); toast.success(`Completion recorded — +${fmtCpd(r.data.cpd_credits)} CPD (self-declared)`); },
    onError,
  });
  return { enroll, complete, openLi, completeLi };
}
